import React from 'react';
import styles from './CadPropertiesInformation.module.scss';
import { CadPropertyValueType } from '../../../../../Models/CadReportValue';
import {
  FieldItemList,
  FieldItemListType
} from '../../CommonBody/FieldItemList/FieldItemList';

const getPropertiesFields = (
  property: CadPropertyValueType
): FieldItemListType[] => {
  return [
    {
      label: 'Case Number',
      value: property.case_number,
      type: 'string'
    },
    {
      label: 'Agency',
      value: property.agency,
      type: 'string'
    },
    {
      label: 'Tag',
      value: property.tag,
      type: 'string'
    },
    {
      label: 'Type',
      value: property.type,
      type: 'string'
    },
    {
      label: 'Color',
      value: property.color,
      type: 'string'
    },
    {
      label: 'Brand',
      value: property.brand,
      type: 'string'
    },
    {
      label: 'Model',
      value: property.model,
      type: 'string'
    },
    {
      label: 'Serial Number',
      value: property.serial_number,
      type: 'string'
    },
    {
      label: 'Storage Location',
      value: property.storage_location,
      type: 'string'
    },
    {
      label: 'Specific Location',
      value: property.specific_location,
      type: 'string'
    },
    {
      label: 'Chain of Custody',
      value: property.chain_of_custody,
      type: 'string'
    },
    {
      label: 'Case Disposition',
      value: property.case_disposition,
      type: 'string'
    },
    {
      label: 'Notes',
      value: property.notes,
      type: 'string'
    }
  ];
};

export interface CadPropertiesInformationProps {
  properties?: CadPropertyValueType[];
}

export const CadPropertiesInformation = ({
  properties
}: CadPropertiesInformationProps): React.ReactElement<CadPropertiesInformationProps> => {
  return (
    <div className={styles.cadPropertiesInformation}>
      <h3 className={styles.title}>Property Information</h3>
      <div className={styles.items}>
        {properties?.map((property, index) => (
          <FieldItemList
            key={property.id}
            title={`${index === 0 ? property.case_number : ''}`}
            fields={getPropertiesFields(property as CadPropertyValueType)}
            hasDivider={index < properties.length - 1}
          />
        ))}
      </div>
    </div>
  );
};
